import { Group, Text, Title } from "@mantine/core";
import { IconMinus } from "@tabler/icons-react";
import { THEME_VARS } from "../../../utils/constants";
import { OrangeCircle } from "../../OrangeCircle/OrangeCircle";
import { StepStatus } from "../ChangeProcess.types";
import { IsDoneBadge } from "./IsDoneBadge";

interface SiteTaskPhaseProps {
  infoText?: string;
  label: string;
  highlight?: boolean;
  status?: StepStatus;
  children?: React.ReactNode;
}

function SiteTaskPhase({
  infoText,
  label,
  status = StepStatus.open,
  highlight,
  children
}: SiteTaskPhaseProps) {
  const isDone = status === StepStatus.done;
  return (
    <div>
      <Group align="center" justify="space-between" wrap="nowrap">
        <Title c={isDone ? "dimmed" : undefined} fw={600} mb={0} order={5}>
          {label}
        </Title>
        {highlight && <OrangeCircle ariaLabel="Hinweis" />}
        <IsDoneBadge isDone={isDone} />
        {status === StepStatus.notRelevant && (
          <IconMinus color={THEME_VARS.primary[6]} />
        )}
      </Group>
      {infoText && !isDone && <Text c="dimmed">{infoText}</Text>}
      {children}
    </div>
  );
}

export { SiteTaskPhase };
